import React from 'react'

const PromofyHeaderSelfServe = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={28}
    viewBox="0 0 180 50"
    fill="none"
  >
    {/* P */}
    <path
      d="M0 10h8c6 0 10 4 10 10s-4 10-10 10H6v12H0V10zm8 14c2.5 0 4-1.5 4-4s-1.5-4-4-4H6v8h2z"
      fill="#004360"
    />
    {/* r */}
    <path
      d="M24 22h5v4c1-2.5 3-4.5 6-4.5v5.5c-3.5 0-5.5 1.5-5.5 5.5v9.5h-5.5V22z"
      fill="#004360"
    />
    {/* o */}
    <path
      d="M38 32c0-6 4.5-10.5 10.5-10.5S59 26 59 32s-4.5 10.5-10.5 10.5S38 38 38 32zm15.5 0c0-3.5-2-5.5-5-5.5s-5 2-5 5.5 2 5.5 5 5.5 5-2 5-5.5z"
      fill="#004360"
    />
    {/* m */}
    <path
      d="M63 22h5v3.5c1.5-2.5 4-4 7-4 3.5 0 6 1.5 7 4.5 1.5-3 4.5-4.5 8-4.5 5 0 8 3 8 8.5v12h-5.5v-11c0-3-1.5-4.5-4-4.5-2.8 0-4.5 2-4.5 5v10.5h-5.5v-11c0-3-1.5-4.5-4-4.5-2.8 0-4.5 2-4.5 5v10.5H63V22z"
      fill="#004360"
    />
    {/* o */}
    <path
      d="M103 32c0-6 4.5-10.5 10.5-10.5S124 26 124 32s-4.5 10.5-10.5 10.5S103 38 103 32zm15.5 0c0-3.5-2-5.5-5-5.5s-5 2-5 5.5 2 5.5 5 5.5 5-2 5-5.5z"
      fill="#004360"
    />
    {/* f */}
    <path
      d="M128 22h4v-3c0-5.5 3-8.5 8.5-8.5 1.5 0 3 .2 4 .5v4.5c-.8-.2-1.5-.3-2.5-.3-2.2 0-3.5 1.2-3.5 3.5v3.3h5.5v4.5h-5.5v15h-5.5v-15h-4v-4.5h-.5z"
      fill="#004360"
    />
    {/* y */}
    <path
      d="M147 22h5.5l5.5 14 5.5-14h5.5l-9 22c-2 5-4.5 7-8.5 7-1.5 0-3-.3-4-.5v-4.5c.8.2 1.8.5 3 .5 2 0 3-.8 4-3l-7.5-17.5z"
      fill="#004360"
    />
  </svg>
)

export default PromofyHeaderSelfServe
